import type { ReactNode } from "react";
import { getSearchHighlightTerms } from "../lib/resources";

type HighlightedTextProps = {
  text: string;
  searchTerm: string;
};

export function HighlightedText({ text, searchTerm }: HighlightedTextProps) {
  const terms = getSearchHighlightTerms(searchTerm);

  if (terms.length === 0) {
    return <>{text}</>;
  }

  const termPattern = terms.flatMap(getTermVariants).map(escapeRegExp).join("|");
  const pattern = new RegExp(`\\b(${termPattern})\\b`, "gi");
  const matchPattern = new RegExp(`^(${termPattern})$`, "i");
  const parts = text.split(pattern).filter(Boolean);

  return (
    <>
      {parts.map((part, index): ReactNode =>
        matchPattern.test(part) ? (
          <mark className="search-highlight" key={`${part}-${index}`}>
            {part}
          </mark>
        ) : (
          part
        )
      )}
    </>
  );
}

function getTermVariants(term: string): string[] {
  const variants = new Set([term]);

  if (term === "retain") {
    variants.add("retention");
    variants.add("retaining");
    variants.add("retained");
  }

  variants.add(term.replace(/isation\b/g, "ization"));
  variants.add(term.replace(/isations\b/g, "izations"));
  variants.add(term.replace(/ising\b/g, "izing"));
  variants.add(term.replace(/ised\b/g, "ized"));
  variants.add(term.replace(/ise\b/g, "ize"));
  variants.add(term.replace(/yse\b/g, "yze"));

  return Array.from(variants).sort((a, b) => b.length - a.length);
}

function escapeRegExp(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
